module.exports = __webpack_public_path__ + "static/media/team-02.dd22906b.jpg";